import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import "../styles/whatsappIcon.css";

const WhatsAppIcon = () => {
    return (
        <div className="whatsapp-icon-container">
            <a
                href="https://wa.me/971582058098?text=Hello%20How%20Can%20I%20Help%20You?"
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp-icon"
                title="Chat on WhatsApp"
            >
                <FaWhatsapp size={36} />
            </a>
        </div>
    );
};

export default WhatsAppIcon;
